import configureStore from './configureStore'
import { IState } from './state';

let instance: any = null;

class StoreSingleton {
  _options: IState;
  _store: any;

  constructor(options: IState) {
    if (!instance) {
      instance = this;
    }

    this._options = options;

    return instance;
  }

  isInit() {
    return typeof this._store !== "undefined";
  }

  getStore() {
    if(!this.isInit()) {
      this._store = configureStore(this._options);
    }
    return this._store;
  }

  getOptions() {
    return this._options;
  }

  setOptions(newOptions: any) {
    let config = Object.assign({}, this._options.config, newOptions.config);
    this._options = Object.assign({}, this._options, {config: {...config}});
  }
}
export default StoreSingleton;
